var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_633_11573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2447 15.689C3.28035 15.6896 5.76919 15.3654 5.76919 15.3654C6.42825 15.3493 7.05572 15.0798 7.5211 14.6129C7.98648 14.1459 8.25395 13.5176 8.26787 12.8585L8.4396 10.8097C9.72535 10.2758 11.104 10.0015 12.4962 10.0023C13.8884 10.0032 15.2667 10.2793 16.5519 10.8147L16.7273 12.86C16.742 13.5185 17.0097 14.146 17.475 14.6124C17.9402 15.0787 18.5671 15.3479 19.2256 15.3641C19.2256 15.3641 21.7109 15.6874 21.7477 15.6868C22.4171 15.6897 23.0606 15.4289 23.539 14.9608C24.0174 14.4927 24.2921 13.855 24.3037 13.1858L24.3907 11.93C24.1052 2.62088 0.817277 2.61469 0.606691 11.9875L0.68738 13.134C0.689423 13.8112 0.959531 14.4601 1.43864 14.9388C1.91775 15.4175 2.56747 15.6876 3.2447 15.689Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_633_11573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/end_call.bf279b721d5079de7a6d86844c0f7a98.svg";
export { ForwardRef as ReactComponent };